import { render } from "./DialogContainer.vue?vue&type=template&id=259dd594&scoped=true"
import script from "./DialogContainer.vue?vue&type=script&lang=js"
export * from "./DialogContainer.vue?vue&type=script&lang=js"

import "./DialogContainer.vue?vue&type=style&index=0&id=259dd594&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259dd594"]])

export default __exports__